//최근 로그인 방식 기록 (로그인 화면의 '최근 로그인' 배지에 사용)
export type LoginMethod = 'NORMAL' | 'NAVER';

export const LAST_LOGIN_METHOD_KEY = 'lastLoginMethod';

//기록이 오래되면 신뢰도가 떨어지므로(기기 주인이 바뀌었을 수 있음) 표시하지 않는다
const EXPIRE_DAYS = 60;
const EXPIRE_MS = EXPIRE_DAYS * 24 * 60 * 60 * 1000;

interface LastLoginRecord {
  method: LoginMethod;
  at: number;
}

//네이버 로그인은 백엔드 oauth 콜백(naeil-backend/src/router/oauth/naver.ts)이
//같은 오리진 팝업에서 동일한 형태로 직접 기록한다. 형식 변경 시 양쪽을 함께 수정할 것.
export function saveLastLoginMethod(method: LoginMethod) {
  try {
    const record: LastLoginRecord = { method, at: Date.now() };
    localStorage.setItem(LAST_LOGIN_METHOD_KEY, JSON.stringify(record));
  } catch (e) {
    //시크릿 모드 등 저장소를 못 쓰는 환경 - 배지만 안 뜨고 로그인은 정상 동작
  }
}

export function getLastLoginMethod(): LoginMethod | null {
  try {
    const raw = localStorage.getItem(LAST_LOGIN_METHOD_KEY);
    if (!raw) return null;

    const record: Partial<LastLoginRecord> = JSON.parse(raw);

    if (record.method !== 'NORMAL' && record.method !== 'NAVER') return null;
    if (typeof record.at !== 'number') return null;
    if (Date.now() - record.at > EXPIRE_MS) return null;

    return record.method;
  } catch (e) {
    //값이 깨졌거나 저장소를 못 쓰는 경우 - 표시하지 않는다
    return null;
  }
}
